<spinner [center]="true" size="la-2x" color="grey" type="ball-triangle-path"></spinner>
<div class="commonBody background">

    <div fxLayout="row">
      <div fxLayout="column" fxFlex="10"></div>
      <div fxLayout="column" fxFlex="80">
           <div fxFlexlayout="row" style="height: 2ch"></div>
        <div class="mat-headline-2 auto_margin" fxLayout="row" fxLayoutAlign="center center">
            Welcome to AppiWorks
        </div>
        <div fxLayout="row wrap" fxLayout.xs="column" fxLayoutAlign="center">
                <div fxLayout="column" fxLayout.xs="row" fxFlex="20"></div>
                <div fxLayout="column" fxLayout.xs="row" fxFlex="20" class="auto_margin"
                fxLayoutAlign="center end">
                  <img style="height: auto;width: 90%"
                  src="https://storage.googleapis.com/jivrus-web-images/products/appiworks/appiworks-logo-3d.png"
                  class="" alt="" loading="eager" />
                </div>

                <div fxLayout="column"  fxFlex="50"  fxLayoutAlign="center start">
                    <div fxLayout="row" fxLayoutAlign="center start" >
                        <span style="margin:0px; color: #b86814;text-align: center;height: 100px;" class="mat-headline-4 auto_margin" i18n><b>{{ 'Application Integration works' | translate}}</b> </span>
                    </div>
                  </div>
                <div fxLayout="column"  fxLayout.xs="row" fxFlex="10"></div>
        </div>



      </div>
      <div fxLayout="column" fxFlex="10"></div>
    </div>


    <div fxLayout="row">

        <div fxLayout="column" fxFlex="10"></div>
        <div fxLayout="column" fxFlex="80" fxFlex.lt-sm="120">

            <div *ngIf="inviteeMap.image_url" fxLayout="row" fxLayoutAlign="center center">
                <img style="height: 100px;width: 100px"
                src="{{inviteeMap.image_url}}"
                class="invitee_img" alt="" loading="eager" />
            </div>
            <div fxLayout="row" *ngIf="entityType == 'workspace' && action == 'accept'"  style="margin-bottom: 0px" ngStyle.xs="font-size: 16px" class="mat-headline-4" fxLayoutAlign="center center">
               {{inviteeMap.first_name}} {{inviteeMap.last_name}} invited you to join {{workspaceMap.name}} workspace
            </div>
            <div fxLayout="row"  style="margin-bottom: 0px;color: brown;" *ngIf="entityType == 'workspace' && action == 'reject'" ngStyle.xs="font-size: 16px" class="mat-headline-4" fxLayoutAlign="center center">
              Oops, You have rejected the invitation from {{inviteeMap.first_name}} {{inviteeMap.last_name}} to join {{workspaceMap.name}} workspace
           </div>

           <div fxLayout="row" *ngIf="entityType == 'bloom' && action == 'accept'"  style="margin-bottom: 0px" ngStyle.xs="font-size: 16px" class="mat-headline-4" fxLayoutAlign="center center">
            {{inviteeMap.first_name}} {{inviteeMap.last_name}} invited you to join {{bloomMap.name}} bloom
           </div>
           <div fxLayout="row"  style="margin-bottom: 0px;color: brown;" *ngIf="entityType == 'bloom' && action == 'reject'" ngStyle.xs="font-size: 16px" class="mat-headline-4" fxLayoutAlign="center center">
             Oops, You have rejected the invitation from {{inviteeMap.first_name}} {{inviteeMap.last_name}} to join {{bloomMap.name}} bloom
           </div>

           <div fxLayout="row" *ngIf="entityType == 'connecion' && action == 'accept'"  style="margin-bottom: 0px" ngStyle.xs="font-size: 16px" class="mat-headline-4" fxLayoutAlign="center center">
            {{inviteeMap.first_name}} {{inviteeMap.last_name}} invited you to join {{connectionMap.name}} connection
           </div>
           <div fxLayout="row"  style="margin-bottom: 0px;color: brown;" *ngIf="entityType == 'connecion' && action == 'reject'" ngStyle.xs="font-size: 16px" class="mat-headline-4" fxLayoutAlign="center center">
             Oops, You have rejected the invitation from {{inviteeMap.first_name}} {{inviteeMap.last_name}} to join {{connectionMap.name}} connection
           </div>

           <div fxLayout="row" *ngIf="entityType == 'flow' && action == 'accept'"  style="margin-bottom: 0px" ngStyle.xs="font-size: 16px" class="mat-headline-4" fxLayoutAlign="center center">
            {{inviteeMap.first_name}} {{inviteeMap.last_name}} invited you to join {{flowMap.name}} flow
           </div>
           <div fxLayout="row"  style="margin-bottom: 0px;color: brown;" *ngIf="entityType == 'connecion' && action == 'reject'" ngStyle.xs="font-size: 16px" class="mat-headline-4" fxLayoutAlign="center center">
             Oops, You have rejected the invitation from {{inviteeMap.first_name}} {{inviteeMap.last_name}} to join {{flowMap.name}} flow
           </div>

           <div fxLayout="row" *ngIf="entityType == 'starch' && action == 'accept'"  style="margin-bottom: 0px" ngStyle.xs="font-size: 16px" class="mat-headline-4" fxLayoutAlign="center center">
            {{inviteeMap.first_name}} {{inviteeMap.last_name}} invited you to join {{starchMap.name}} starch
           </div>
           <div fxLayout="row"  style="margin-bottom: 0px;color: brown;" *ngIf="entityType == 'starch' && action == 'reject'" ngStyle.xs="font-size: 16px" class="mat-headline-4" fxLayoutAlign="center center">
             Oops, You have rejected the invitation from {{inviteeMap.first_name}} {{inviteeMap.last_name}} to join {{starchMap.name}} starch
           </div>

           <div *ngIf="isActionRepeats" fxLayout="row"  style="margin-bottom: 0px;color: brown;" ngStyle.xs="font-size: 16px" class="mat-headline-4" fxLayoutAlign="center center">
              {{actionMessage}}
           </div>


            <div *ngIf="action == 'accept' && !isActionRepeats" fxFlexlayout="row" class="wrap" fxLayoutAlign="center center" >
                <button mat-stroked-button class="button" color="primary" (click)="navigateToSignUp()"  type="button">
                    Sign-in to Join
                </button>
            </div>
            <div *ngIf="!isAccepted || isActionRepeats" fxFlexlayout="row" class="wrap" fxLayoutAlign="center center" >
              <button mat-stroked-button class="button" color="primary" (click)="navigateToGuest()"  type="button">
                  Explore AppiWorks
              </button>
          </div>
            <div fxFlexlayout="row" fxLayoutAlign="center center" style="height: 5ch" fxHide.lt-sm></div>
          </div>
        <div fxLayout="column" fxFlex="10"></div>
      </div>

      <div fxLayout="row">
        <div fxLayout="column" fxFlex="3"></div>
        <div fxLayout="column" fxFlex="94">
          <br/>
          <mat-card appearance="outlined" class="section2">
            <guest-section2></guest-section2>
          </mat-card>
          <br/>
        </div>
        <div fxLayout="column" fxFlex="3"></div>
      </div>

  </div>
